//=====================================================
//　共通定義
//=====================================================

//定数
export namespace Config {
    
}

//予約タイプ
export enum ReservationType {
    None,
    First,
    Return,
    ReFirst,
    Change,
    Cancel
}

//天気コード
export enum Weather {
    "icon-weather-sunny" = 1,
    "icon-weather-sunny-l-cloudy",
    "icon-weather-sunny-l-rainy",
    "icon-weather-sunny-l-snowy",
    "icon-weather-sunny-s-cloudy",
    "icon-weather-sunny-s-rainy",
    "icon-weather-sunny-s-snowy",
    "icon-weather-cloudy",
    "icon-weather-cloudy-l-sunny",
    "icon-weather-cloudy-l-rainy",
    "icon-weather-cloudy-l-snowy",
    "icon-weather-cloudy-s-snowy",
    "icon-weather-cloudy-s-rainy",
    "icon-weather-cloudy-s-sunny",
    "icon-weather-rainy",
    "icon-weather-rainy-l-sunny",
    "icon-weather-rainy-l-cloudy",
    "icon-weather-rainy-l-snowy",
    "icon-weather-rainy-s-sunny",
    "icon-weather-rainy-s-cloudy",
    "icon-weather-rainy-s-snowy",
    "icon-weather-snowy",
    "icon-weather-snowy-l-sunny",
    "icon-weather-snowy-l-cloudy",
    "icon-weather-snowy-l-rainy",
    "icon-weather-snowy-s-sunny",
    "icon-weather-snowy-s-cloudy",
    "icon-weather-snowy-s-rainy",
}

//予約空き状況ステータス
export enum StatusClass {
    "is-closed" = 0,
    "is-vacant",
    "is-few-vacant",
    "is-no-vacant",
    "is-reserve-phone",
}

//必須・任意
export enum InputTag {
    Required,
    Optional,
    EitherRequired
}

//ログイン状態
export enum LoginStatusType {
    Login,          //ログイン有効
    LoginExpired,   //ログイン期限切れ
    LogOut          //ログアウト
}